module.exports = __webpack_public_path__ + "img/img-web-subsidio-madres-no-gestantes-adopcion.172d1dab.jpg";